import { render, staticRenderFns } from "./PosesDialog.vue?vue&type=template&id=00ff8d64&scoped=true"
import script from "./PosesDialog.vue?vue&type=script&lang=js"
export * from "./PosesDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00ff8d64",
  null
  
)

export default component.exports